import MetricsTable from "../MetricsTable/MetricsTable";
import { table_getInternalLinksData } from "../../connections";
import {useEffect, useState} from "react";

interface TableData {
    name: string;
    count_of_learners: number;
    count_of_interacted: number;
}
type ApiResponse = { data: TableData[] };
export default function LinkInteractionsTable() {
    const [data, setData] = useState<string[][]>([])
    useEffect(() => {
        const getData = async () => {
            const response: ApiResponse = await table_getInternalLinksData();
            const stringValues: string[][] = response.data.map(item => [
                item.name,
                item.count_of_learners.toString(),
                item.count_of_interacted.toString(),
            ]);
            setData(stringValues);
        }
        getData();
    }, []);
    return (
        <MetricsTable
            title="How often did the learner click each course link?"
            headers={["Name","Count of\nLearners","Count of\nInteracted"]}
            data={data}
            table_width={window.innerWidth < 640 ? "100%" : "50%"}
        />
    )
}